export default __webpack_public_path__ + "static/media/washing-appliances.e5ed009f.svg";